
const adventCalendar = document.querySelector('.advent-calendar-modal-wrapper');
// const adventCalendarSnowflakes = adventCalendar.querySelector('.snowflake-container');
let snowflakeContainer;
let start_date;
const start_date_string = adventCalendar.dataset.startDate;

let isActive = false;

if ( start_date_string ) {
    start_date = parseCustomDate( start_date_string );
    // console.log('📅 START DATE: ', start_date );
}

if ( adventCalendar ) {
    let snowflakeInterval;
    let randomShakeInterval;
    
    const adventContentContainer = adventCalendar.querySelector('.advent-content-container');
    
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        // console.log('🚀🚀🚀 Clicked Stuff!', target );
        
        // Open + Close Modal JS
        if ( target.closest('[open-advent-calendar-modal]') || target.closest('[href="#open-advent-calendar-modal"]') ) {
            e.preventDefault();
            
            // Open Modal 
            adventCalendar.classList.add('modal-open');
            // console.log('🚀🚀🚀 Clicked features trigger!');
            
            // Lock Scrolling
            document.documentElement.classList.add('lock-scroll');
            
            // Create Snowflake container
            const snowflakeContainerNode = document.createElement('div');
            snowflakeContainerNode.classList.add('snowflake-container');
            adventCalendar.appendChild( snowflakeContainerNode );
            
            // Select Snowflake Container - Start Snowing
            snowflakeContainer = document.querySelector('.advent-calendar-modal-wrapper .snowflake-container');
            snowflakeInterval = setInterval( () => {
                createSnowflake(snowflakeContainer);
            }, 200);
            
            // Start Randmo Shake Interval
            randomShakeInterval = setInterval( randomShakeClass, 3000 );
            
            if ( !isActive ) {
                const adventBlocks = adventCalendar.querySelectorAll('.advent-block');
                if ( adventBlocks ) {
                    updateCountdowns(adventBlocks);
                    setInterval(() => {
                        updateCountdowns(adventBlocks);
                    }, 1000);
                }
            }
            
            isActive = true;
            
        } else if ( target.closest('[close-advent-calendar-modal]') || ( target.classList.contains('advent-calendar-modal-wrapper') && !adventContentContainer.classList.contains('advent-open') ) ) {
            adventCalendar.classList.remove('modal-open');
            adventContentContainer.classList.remove('advent-open');
            // console.log('🚀🚀🚀 Clicked features close!');
            
            // Allow Scrolling 
            document.documentElement.classList.remove('lock-scroll');
            
            snowflakeContainer = adventCalendar.querySelector('.advent-calendar-modal-wrapper .snowflake-container');
            snowflakeContainer.remove();
            
            clearInterval( snowflakeInterval );
            clearInterval( randomShakeInterval );
        }
        
        
        // Open Prize Modal
        if ( target.closest('.advent-block') && target.classList.contains('unlocked') ) {
            target.classList.add('block-open');
            adventContentContainer.classList.add('advent-open');
            
            sectionRenderPrizeContent();
        }
        
        
        // Close Prize modal
        if ( target.closest('.close-advent-btn') || target.classList.contains('advent-calendar-modal-wrapper') ) {
            adventContentContainer.classList.remove('advent-open');
            
            const openAdventBlocks = adventCalendar.querySelectorAll('.advent-block.block-open');
            // openAdventBlocks.forEach( adventBlock => {
                // adventBlock.classList.remove('block-open');
            // })
        }
        
        
        if ( target.closest('.signup-content') ) {
            adventCalendar.classList.remove('hidden');
        }
        
    });
    
    
}



function formatTimeUnit(value) {
    // return value < 10 ? '0' + value : value;
    return value
}

// Get Date from Section Setting
function parseCustomDate(dateString) {
    // Split date and time
    const [datePart, timePart] = dateString.split(' ');

    // Split the date part (YYYY-DD-MM)
    const [year, month, day] = datePart.split('-').map(Number);

    // Split the time part (HH:MM)
    const [hour, minute] = timePart.split(':').map(Number);

    // Create a Date object in UTC (month is zero-indexed)
    const dateObject = new Date(Date.UTC(year, month - 1, day, hour, minute));

    return dateObject;
}


// Set Up Countdowns 
function updateCountdowns(elements) {
    const now = new Date();
    const nowInGMT = new Date(now.toISOString());
    // console.log('nowInGMT', nowInGMT)
    
    elements.forEach(el => {
        const dateAttr = el.dataset.unlockDate;
        const unlockDate = parseCustomDate(dateAttr);
        
        // Calculate time difference
        const timeDifference = unlockDate - nowInGMT;
        const oneDayInMillis = 1000 * 60 * 60 * 24;
        
        // Check if the date has passed and is more than 24 hours old
        if (timeDifference < 0 && Math.abs(timeDifference) > oneDayInMillis) {
            el.classList.add('expired');
            el.classList.remove('unlocked', 'block-open');
            el.setAttribute('data-text', 'Expired' );
        } else if (timeDifference > 0) {
            // Calculate days, hours, minutes, and seconds for future dates
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
            
            
            // Format the countdown
            let countdownText;
            countdownText = `${formatTimeUnit(days)}d ${formatTimeUnit(hours)}h ${formatTimeUnit(minutes)}m ${formatTimeUnit(seconds)}s`;
            
            // Don't display days if = 0
            if ( days == 0 ) {
                countdownText = `${formatTimeUnit(hours)}h ${formatTimeUnit(minutes)}m ${formatTimeUnit(seconds)}s`;
            }
            
            // Don't display days or hours if they are = 0
            if ( days == 0 && hours == 0 ) {
                countdownText = `${formatTimeUnit(minutes)}m ${formatTimeUnit(seconds)}s`;
            }
            
            // Update the countdown display
            el.setAttribute('data-text', `${ countdownText }` );
            
            // Add the 'locked' class for active countdowns
            el.classList.add('locked');
        } else {
            // If the date is past but not more than 24 hours old
            el.classList.remove('expired', 'locked');
            el.classList.add('unlocked');
            // el.setAttribute('data-text', 'Unlocked' );
        }
    });
}



// Snowflake JS
function createSnowflake(container) {
    const snowflake = document.createElement('div');
    snowflake.classList.add('snowflake');
    // snowflake.textContent = '•';
    const randomWidth = Math.random() * 9 + 3 + 'px';
    snowflake.style.width = randomWidth;
    snowflake.style.height = randomWidth;
    snowflake.style.left = Math.random() * window.innerWidth + 'px';
    snowflake.style.animation = `snowflakeFall ${ Math.random() * 4 + 4 }s linear infinite, snowflakeSideWays ${ Math.random() * 2 + 1 }s ease-in-out infinite`;
    
    container.appendChild( snowflake );
    
    setTimeout(() => {
        snowflake.remove();
    }, Math.random() * 5000 + 5000);
}


// Random Shake 
function randomShakeClass() {
    const activeBlocks = adventCalendar.querySelectorAll('.advent-block.unlocked, .advent-block.locked');
    
    // Check if elements array is empty
    if (activeBlocks.length === 0) {
        // console.log('No elements to toggle class on.');
        return;
    }
    
    // Generate a random index based on the length of the elements array
    const randomIndex = Math.floor(Math.random() * activeBlocks.length);
    
    // Get the element at the random index
    const randomBlock = activeBlocks[randomIndex];
    
    // Toggle the class on the selected randomBlock
    randomBlock.classList.add('shake');
    
    setTimeout( () => {
        randomBlock.classList.remove('shake');
    }, 1000 );
}



async function sectionRenderPrizeContent() {
    // const sectionId = adventCalendar.dataset.sectionId; 
    const sectionId = 'hb-advent-calendar'; 
    const adventCalendarPrizeContent = document.querySelector('.advent-calendar-modal-wrapper .advent-content-container .advent-block-content');
    adventCalendarPrizeContent.classList.add('loading');

    fetch(`${ window.Shopify.routes.root}?section_id=${ sectionId }`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.text(); // Parse the response as JSON
        })
        .then((data) => {
            // Get Section HTML
            const html = new DOMParser().parseFromString( data, 'text/html' );
            const newPrizeContent = html.querySelector('.advent-calendar-modal-wrapper .advent-content-container .advent-block-content');
            
            adventCalendarPrizeContent.innerHTML = newPrizeContent.innerHTML;
            adventCalendarPrizeContent.classList.remove('loading');
        })
        .catch((error) => {
            console.error("Error:", error);
        });
}